// extracted by mini-css-extract-plugin
export default {"box":"FilterCity_box__RO7mS","input":"FilterCity_input__30ZfT"};